module.exports = __webpack_public_path__ + "static/media/logo-whatsapp.68512b9e.png";